var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"pGrv-fbvLRcr6Cw2yPgC5"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: 'https://32b71c2667d074dedd43ae42e181be42@o4508895232589824.ingest.us.sentry.io/4508913036820480',

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
})

console.log('Sentry environment:', process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT)